"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var theme_1 = require("../../theme");
theme_1.registerTheme('funnel', {});
//# sourceMappingURL=theme.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@antv/g2plot/lib/plots/funnel/theme.js
// module id = 903
// module chunks = 37